import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function TenantLogo ( props ) {

    return <BasicCrudScreenType id="TenantLogo" table="TenantLogo" view="VwTenantLogo" />

}

export default TenantLogo;
